import { Media } from '@/payload-types'
import React, { useState } from 'react'
import FlowiteIconComponent from '@/components/flowbite-icon/flowbiteIcon'
import ImageComponent from '@/components/media/imageComponent'
import VideoComponent from '@/components/media/videoComponent'
import GalleryCaption from '../embedded-gallery/embeddedGalleryCaption'
interface IProps {
  media?: (string | Media)[]
  timeStamp?: {
    value?: string | null
    mediaId?: (string | null) | Media
  }[]
  onImageClick?: (imageSrc: string) => void
}

export const MediaCarousel = ({ media, timeStamp, onImageClick }: IProps) => {
  const [currentMediaIndex, setCurrentMediaIndex] = useState(0)
  const [showLeftButton, setShowLeftButton] = useState(false)
  const [showRightButton, setShowRightButton] = useState(media != undefined && media?.length > 1)
  const [captionVisibility, setCaptionVisibility] = useState<Record<number, boolean>>({})
  const hideCaption = (index: number) => {
    console.log('hideCaption', index)

    setCaptionVisibility((prev) => ({
      ...prev,
      [index]: false,
    }))
  }

  const isCaptionVisible = (index: number) => {
    return captionVisibility[index] !== false
  }
  if (typeof media === 'object') {
    const currentMedia = media[currentMediaIndex]

    const handleLeftClick = () => {
      const prevIndex = Math.max(currentMediaIndex - 1, 0)
      setCurrentMediaIndex(prevIndex)
      setShowRightButton(prevIndex < media?.length - 1)
      setShowLeftButton(prevIndex > 0)
    }
    const handleRightClick = () => {
      const nextIndex = Math.min(currentMediaIndex + 1, media?.length - 1)
      setCurrentMediaIndex(nextIndex)
      setShowLeftButton(nextIndex > 0)
      setShowRightButton(nextIndex < media?.length - 1)
    }
    const timeStampValue = timeStamp?.find(
      (ts) =>
        ts.mediaId &&
        typeof ts.mediaId !== 'string' &&
        'id' in ts.mediaId &&
        ts.mediaId.id ===
          (typeof currentMedia === 'object' && currentMedia ? currentMedia.id : currentMedia),
    )?.value
    if (typeof currentMedia === 'string' || currentMedia === undefined) return null
    return (
      <div className="relative rounded-lg w-auto h-full bg-black">
        <div>
          {currentMedia.mimeType?.startsWith('image') ? (
            <span>
              <div
                className={`w-full h-[185px] sm:!h-[330px] ${onImageClick ? 'cursor-pointer' : ''}`}
                onClick={() =>
                  currentMedia.mimeType?.startsWith('image')
                    ? onImageClick?.(
                        `${
                          process.env.NEXT_PUBLIC_PAYLOAD_URL
                            ? process.env.NEXT_PUBLIC_PAYLOAD_URL
                            : ''
                        }${
                          currentMedia.sizes?.medium?.url
                            ? currentMedia.sizes?.medium?.url
                            : currentMedia.url
                        }`,
                      )
                    : undefined
                }
              >
                <ImageComponent
                  src={`${
                    process.env.NEXT_PUBLIC_PAYLOAD_URL ? process.env.NEXT_PUBLIC_PAYLOAD_URL : ''
                  }${
                    currentMedia.sizes?.medium?.url
                      ? currentMedia.sizes?.medium?.url
                      : currentMedia.url
                  }`}
                  alt={currentMedia.title}
                  className="!object-contain"
                  width={currentMedia.sizes?.medium?.width}
                  height={currentMedia.sizes?.medium?.height}
                />
              </div>
              {currentMedia.originalUrl && (
                <GalleryCaption
                  imageCaption={getImageCaption(currentMedia)}
                  showCaptions={isCaptionVisible(currentMediaIndex)}
                  hideCaptions={() => hideCaption(currentMediaIndex)}
                />
              )}
            </span>
          ) : (
            <div className="w-full h-[185px] sm:!h-[330px] border border-gray-200 rounded-lg">
              <VideoComponent videoData={currentMedia} timeStamp={timeStampValue} />
              {currentMedia.originalUrl && (
                <GalleryCaption
                  imageCaption={getImageCaption(currentMedia)}
                  showCaptions={isCaptionVisible(currentMediaIndex)}
                  hideCaptions={() => hideCaption(currentMediaIndex)}
                />
              )}
            </div>
          )}
        </div>
        {showLeftButton && (
          <button
            onClick={handleLeftClick}
            className="absolute left-2 top-1/2 -translate-y-1/2 border border-black rounded-full bg-[#E5E7EB] opacity-80 w-[40px] h-[40px] flex justify-center items-center m-1 z-50"
          >
            <FlowiteIconComponent iconType="AngleLeft" className="text-black !m-0" />
          </button>
        )}
        {showRightButton && (
          <button
            onClick={handleRightClick}
            className="absolute right-2 top-1/2 -translate-y-1/2 border border-black rounded-full bg-[#E5E7EB] opacity-80 w-[40px] h-[40px] flex justify-center items-center m-1 z-50"
          >
            <FlowiteIconComponent iconType="AngleRight" className="text-black !m-0" />
          </button>
        )}
      </div>
    )
  }
}

export function getImageCaption(media: Media) {
  return `Source: ${
    typeof media.source === 'object' && media.source?.platform != 'other'
      ? `${media.source?.title}, `
      : ''
  }  ${media.handle ? ` ${media.handle}, ` : ''} 
  ${media.datePosted ? `${new Date(media.datePosted).toLocaleDateString()}, ` : ''}${
    media.originalUrl
  }`
}
